import React, { useState } from "react";
import styled from "styled-components";
import { Button, Dropdown, Menu, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import Icon from "@ant-design/icons";
import { ReactComponent as reset } from "images/filter/reset.svg";
import SearchBar from "ui/components/Dashboard/Filter/Searchbar";
import { ReactComponent as Reset } from "images/filter/reset.svg";
import RequestCard from "./RequestCard";
import { useGetRequests } from "lib/hooks/requests";
import { Pagination } from "antd";

// Reuse the styled components from AdminOrganizers
const Container = styled.div`
  margin: 1rem;
  display: flex;
  flex-direction: column;
`;

const Topdiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1rem;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const RequestCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 800px;
`;

const Left = styled.div`
  width: 60%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const ResetText = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

// New header styles based on AdminOrganizers
const Bottom = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  margin-top: 1rem;
  @media (max-width: 1024px) {
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  }
`;

const OrganizersHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 800px;
  background-color: #f9faff;
  border-radius: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-bottom: 2rem;
`;

const IDColumn = styled.div`
  width: 15%;
  margin-left: 1rem;
`;

const EmailColumn = styled.div`
  width: 30%;
`;

const StatusColumn = styled.div`
  width: 20%;
`;

const UserTypeColumn = styled.div`
  width: 15%;
`;

const DateColumn = styled.div`
  width: 20%;
`;

const HeaderText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #2f2f2f;
  display: flex;
  align-items: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  @media (max-width: 1024px) {
    font-size: 12px;
  }
`;

const OrganizerPayment: React.FC = () => {
  // State for filters
  const [paymentStatusFilter, setPaymentStatusFilter] = useState<string | null>(null);
  const [selectedPaymentStatusLabel, setSelectedPaymentStatusLabel] = useState<string>("Payment status");
  const [searchQuery, setSearchQuery] = useState("");

  // Add pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Fetch requests data
  const { data, isLoading, isError } = useGetRequests({
    page: currentPage,
    limit: pageSize,
    status: paymentStatusFilter || undefined,
    search: searchQuery,
    userType: "organizer",
  });

  console.log("API Response:", data);
  console.log("Requests Data:", data?.data);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    // Add your search logic here
  };

  // Payment status filter menu
  const paymentStatusMenu = (
    <Menu
      onClick={e => {
        setPaymentStatusFilter(e.key === "all" ? null : e.key);
        setSelectedPaymentStatusLabel(
          e.key === "all"
            ? "Payment status"
            : e.key === "ongoing"
              ? "Ongoing"
              : e.key === "complete"
                ? "Complete"
                : "Approved",
        );
        // Add your filter logic here
      }}
    >
      <Menu.Item key="all">All statuses</Menu.Item>
      <Menu.Item key="ongoing">Ongoing</Menu.Item>
      <Menu.Item key="complete">Complete</Menu.Item>
      <Menu.Item key="approved">Approved</Menu.Item>
    </Menu>
  );

  // Reset all filters
  const handleResetFilters = () => {
    setPaymentStatusFilter(null);
    setSelectedPaymentStatusLabel("Payment status");
    setSearchQuery("");
    // Add any additional reset logic here
  };

  return (
    <Container>
      <Topdiv>
        <Left>
          <SearchBar onSearch={handleSearch} />
        </Left>
        <Right>
          <Dropdown overlay={paymentStatusMenu} trigger={["click"]}>
            <Button style={{ fontSize: "13px" }}>
              <Space>
                {selectedPaymentStatusLabel}
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>

          <Button type="default" onClick={handleResetFilters} style={{ fontSize: "13px" }}>
            <Space>
              <Reset />
              <ResetText>Reset filters</ResetText>
            </Space>
          </Button>
        </Right>
      </Topdiv>

      {/* Add the header section */}
      <Bottom>
        <OrganizersHeader>
          <IDColumn>
            <HeaderText>ID</HeaderText>
          </IDColumn>
          <EmailColumn>
            <HeaderText>Email</HeaderText>
          </EmailColumn>
          <StatusColumn>
            <HeaderText>Status</HeaderText>
          </StatusColumn>
          <UserTypeColumn>
            <HeaderText>User Type</HeaderText>
          </UserTypeColumn>
          <DateColumn>
            <HeaderText>Date Created</HeaderText>
          </DateColumn>
        </OrganizersHeader>

        {isLoading ? (
          <p>Loading...</p>
        ) : isError ? (
          <p>Error loading requests</p>
        ) : Array.isArray(data) ? ( // Check if data is directly the array
          data.length > 0 ? (
            <>
              <RequestCardContainer>
                {data.map(request => (
                  <RequestCard key={request.id} request={request} />
                ))}
              </RequestCardContainer>
              <PaginationContainer>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={data.length} // Or use another property if available
                  onChange={page => setCurrentPage(page)}
                  size="small"
                />
              </PaginationContainer>
            </>
          ) : (
            <p>No requests found</p>
          )
        ) : (
          <p>No requests found</p>
        )}
      </Bottom>
    </Container>
  );
};

export default OrganizerPayment;
